import { render } from "./Compras2Mobile.vue?vue&type=template&id=7f3ca145"
import script from "./Compras2Mobile.vue?vue&type=script&lang=js"
export * from "./Compras2Mobile.vue?vue&type=script&lang=js"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__